import { getDeviceInfo } from "@/utils/Device";
import { getUser } from "@/utils/User";
import axios from "axios";
import { isLocalhost, backendApi, getServerType } from "@/utils/URL";

export const sendLogs = async (language, message, details = '') => {

    if(!isLocalhost()){

        if(
            !message.includes('Unable to preload CSS') &&
            !message.includes('Failed to fetch dynamically imported module') &&
            !message.includes('Importing a module script failed') &&
            !message.includes('The node to be removed is not a child of this node')
        ){

            const device = getDeviceInfo();

            const user = getUser();

            const from = 'frontend '+getServerType();

            const data = {
                language: language,
                from: from,
                log: JSON.stringify(message),
                url: window.location.href,
                device: device,
                user: user?.email
            };

            if(details.length > 0){
                data.details = details;
            }

            const apiUrl = backendApi();

            if(apiUrl){
                await axios.post(apiUrl+'/log',data);
                /*.then(function (response){
                })
                .catch(function (error){
                });*/
            }
        }
    }
}